module.exports = __webpack_public_path__ + "media/images/redesign-images/home/house-brands-b81599c5e763a656c1d45d67a9d29a32.png";